export const getSearchParams = (): string => {
  if (window.location.hash) {
    return `?${window.location.hash.split('?')[1]}`
  }

  return window.location.search
}

export function getUrlParams(search?: string): { [key: string]: string } {
  const searchP = search || getSearchParams()
  const hashes = searchP.slice(searchP.indexOf('?') + 1).split('&')
  return hashes.reduce((params, hash) => {
    const [key, val] = hash.split('=')
    if (!key) {
      return Object.assign(params, {})
    }

    return Object.assign(params, {
      [key]: decodeURIComponent(val)?.replace('+', ' '),
    })
  }, {})
}

export const getSkip = (page: string | number, limit: number): number => {
  if (!page) {
    return 0
  }

  const num = Number(page)

  if (isNaN(num)) {
    return 0
  }

  return (num - 1) * limit
}
